import Actions      from "../../model/constant/actions"
import ReducerUtils from "../../utils/ReducerUtils"

export default ReducerUtils.createReducer<boolean>(false,{
  [Actions.RETRIEVING_CLEANER_REFERENCE] : (state,action) => action.status,
})
